var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isStatusLoading
    ? _c("LoadingAnimation", { attrs: { "animation-style": "bars" } })
    : _c(
        "div",
        { staticClass: "w-100 user-modal-register-plan-select-view px-2" },
        [
          _vm.isLegacy() === true
            ? _c("div", { staticStyle: { "max-width": "607px" } }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "alert alert-warning gap-10 d-flex flex-column align-items-center p-5",
                  },
                  [
                    _c("p", { staticClass: "font-size-sm-200" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")(
                            "You're still on a legacy subscription plan"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "font-size-sm-125" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")(
                            'Your legacy subscription does not allow to buy "Pay As You Go" Credits.'
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "font-size-sm-125" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")(
                            "Please contact our support team to cancel your legacy subscription now and get a partial refund."
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "font-size-sm-125" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")(
                            'You can then choose one of our new subscription plans and get additional "Pay As You Go" Credits as needed.'
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-lg contact-btn",
                        on: { click: _vm.openContactSupport },
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("trans")("Contact support"))),
                        ]),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isLegacy() === false
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "mb-5 text-center" }, [
                    _c(
                      "p",
                      { staticClass: "font-weight-bold font-size-200 mb-0" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("trans")("Choose Your Plan")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-center text-center mb-4 ml-n1 mt-n3 flex-wrap",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex-grow-1 ml-1 mt-3 white-space-nowrap",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "btn btn-white rounded border btn-lg mb-0 py-3 px-4 w-100",
                              class: {
                                "outline-info shadow-info":
                                  _vm.isIndividualSelected,
                              },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedPlan,
                                    expression: "selectedPlan",
                                  },
                                ],
                                staticClass: "mr-1 vuetiful-form-radio-button",
                                attrs: {
                                  "data-user-modal-input-plan-individual": "",
                                  type: "radio",
                                  name: "u_plan",
                                  value: "individual",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.selectedPlan,
                                    "individual"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.selectedPlan = "individual"
                                  },
                                },
                              }),
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm._f("trans")("Individual")) +
                                  "\n                "
                              ),
                              _c("i", { staticClass: "far fa-user m-l-5" }),
                              _vm._v(" 1\n            "),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex-grow-1 ml-1 mt-3 white-space-nowrap position-relative",
                        },
                        [
                          !_vm.isTeamsEnabled
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "badge bg-info px-3 position-absolute text-white z-index-1",
                                  staticStyle: { top: "-8px", right: "4px" },
                                },
                                [_vm._v(_vm._s(_vm._f("trans")("Coming soon")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass:
                                "btn btn-white rounded border btn-lg mb-0 py-3 px-4 w-100",
                              class: {
                                "outline-info shadow-info": _vm.isTeamSelected,
                                "disabled pointer-events-none":
                                  !_vm.isTeamsEnabled,
                              },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedPlan,
                                    expression: "selectedPlan",
                                  },
                                ],
                                staticClass: "mr-1 vuetiful-form-radio-button",
                                attrs: {
                                  "data-user-modal-input-plan-team": "",
                                  type: "radio",
                                  name: "u_plan",
                                  value: "team",
                                  disabled: !_vm.isTeamsEnabled,
                                },
                                domProps: {
                                  checked: _vm._q(_vm.selectedPlan, "team"),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.selectedPlan = "team"
                                  },
                                },
                              }),
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm._f("trans")("Team")) +
                                  "\n                "
                              ),
                              _c("i", {
                                staticClass: "far fa-user-friends m-l-5",
                              }),
                              _vm._v(" 2-50\n                "),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mb-4 rounded bg-white border p-4" },
                    [
                      _c("p", { staticClass: "mb-1 font-size-150" }, [
                        _vm._v(_vm._s(_vm._f("trans")("Premium"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "color-stripe flex-row w-100 mb-4" },
                        _vm._l(8, function (n) {
                          return _c("div", { class: "bg-main-" + n })
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "list-unstyled mb-4" },
                        _vm._l(_vm.features, function (feature, idx) {
                          return _c(
                            "li",
                            {
                              staticClass: "py-3 d-flex align-items-baseline",
                              class: { "border-top": idx !== 0 },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-check text-success",
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "pl-1",
                                domProps: { innerHTML: _vm._s(feature) },
                              }),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "bg-gray-light rounded p-3 d-flex flex-column align-items-start",
                        },
                        [
                          _c("strong", { staticClass: "font-size-125" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.infoBoxTitleText) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.infoBoxBodyText),
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("ButtonWithLoadingState", {
                    staticClass:
                      "btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded mb-4",
                    attrs: {
                      "data-user-modal-button-submit": "",
                      icon: "fa fa-arrow-right lh-1",
                      text: _vm._f("trans")("Continue"),
                      "is-state-loading": _vm.isSubmitting,
                      "show-icon-after-text": true,
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.goToChooseBilling.apply(null, arguments)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }